import script from "./inbox-talking-point-bucket-panel.vue?vue&type=script&setup=true&lang=ts"
export * from "./inbox-talking-point-bucket-panel.vue?vue&type=script&setup=true&lang=ts"

import "./inbox-talking-point-bucket-panel.vue?vue&type=style&index=0&id=1d3299ae&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d3299ae"]])

export default __exports__